export const title = ""
export const subtitle = "Contact"
export const description = [
  {
    bold: false,
    text: "pushfusion is a brand owned by Binary Forge and its located at the Digital Media Centre, in the centre of Barnsley, South Yorkshire.",
  },
]
export const contactData = [
  {
    id: 1,
    name: "Phone",
    address: ["+44 (0)1924 654 002"],
  },
  {
    id: 2,
    name: "Email",
    address: ["info@binaryforge.io", "demo@pushfusion.io"],
  },
  {
    id: 3,
    name: "Write",
    address: [
      "Binary Forge Solutions Ltd.",
      "DMC 01, County Way",
      "Barnsley - South Yorkshire",
      "S70 2JW",
    ],
  },
]
